import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import useDeviceType from "../common/useDeviceType";
import { useRef } from "react";
import ModalPop from "./ModalPop";

const Banner = () => {
  const bannerList = [
    {
      pc: "images/banner1.png",
      mo: "images/bannerM1.png",
    },
    {
      pc: "images/banner2.png",
      mo: "images/bannerM2.png",
    },
    {
      pc: "images/banner3.png",
      mo: "images/bannerM3.png",
    },
    {
      pc: "images/banner1.png",
      mo: "images/bannerM1.png",
    },
    {
      pc: "images/banner2.png",
      mo: "images/bannerM2.png",
    },
    {
      pc: "images/banner3.png",
      mo: "images/bannerM3.png",
    },
  ];

  const isMobile = useDeviceType();

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <p className="block lg:hidden relative w-full text-center h-fit bg-primary text-white px-2 pt-0.5 -mt-1 border border-point">
        <span className="text-point">열쇠복사와 차문잠김 문제</span>는 다루지
        않습니다.
      </p>
      <div className=" relative w-full h-full xl:pt-3">
        <Swiper
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          }}
          loop={true}
          loopAdditionalSlides={2}
          modules={[Autoplay]}
          className="mySwipe relative w-full h-full"
        >
          {bannerList.map((v, i) => (
            <SwiperSlide key={`banner-${i}`} className="relative w-full h-full">
              <img
                alt={`키플레이어 도어락 교체·설치 안내 배너 ${i + 1}`}
                onClick={openfunc}
                className="!relative w-full h-full object-contain cursor-pointer"
                src={isMobile ? v.mo : v.pc}
                width={2558}
                height={609}
              />
              <div className="md:hidden absolute left-4 bottom-14 w-fit h-fit grid grid-rows-2 gap-3 z-10">
                <div
                  onClick={() => (window.location.href = "tel:010-8799-3313")}
                  className=" relative w-fit h-fit rounded-full pt-2 pb-1.5 px-8 bg-point"
                >
                  <p>전화상담 바로가기</p>
                </div>
                <div
                  onClick={openfunc}
                  className=" relative w-full h-fit rounded-full pt-2 pb-1.5 bg-[#ff3700] text-white text-center"
                >
                  <p>
                    <span className="text-[#fff700]">긴급출동 요청</span>{" "}
                    바로가기
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default Banner;
